import React, { useEffect, useState } from 'react';
import ApolloService from '../../Services/ApolloService';
import AppLoader from '../../components/AppLoader';
import ConfigurationInterface from '../../graphql/ConfigurationInterface';
import Layout from '../../components/Layout/Layout';
import OAuthService from '../../Services/OAuth/OAuthService';
import RequestConfigurationFactory from '../../Services/Request/RequestConfigurationFactory';

interface LoaderProps {
  fullScreen?: boolean;
}

const withBootstrap =
  (
    ComponentDefinition: React.ComponentType,
    DefaultLoaderComponent: React.ComponentType<LoaderProps> = AppLoader
  ) =>
  (props: any) => {
    const { LoaderComponent } = props;
    const [bootstrapReady, setBootstrapReady] = useState(false);

    useEffect(() => {
      (async () => {
        const configInterface = new ConfigurationInterface(undefined, true);
        const config = await configInterface.bootstrap();

        RequestConfigurationFactory.setup(config);
        OAuthService.setupOAuthUrls(config.oauthUrls);
        ApolloService.refreshApiUrl();

        setBootstrapReady(true);
      })();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!bootstrapReady) {
      return LoaderComponent ? (
        <LoaderComponent />
      ) : (
        <Layout>
          <DefaultLoaderComponent fullScreen />
        </Layout>
      );
    }

    return <ComponentDefinition {...props} />;
  };

export default withBootstrap;
